import { Moment } from 'moment';
import { DEFAULT_LANGUAGE } from '@/shared/constants/Language';
import Brand from '@/shared/models/Brand';
import Outlet from '@/shared/models/Outlet';
import BookingItemType from '../constants/BookingItemType';

export interface BookingItemId {__bookingItemId: number}

export default class BookingItem {
  id: BookingItemId | null = null;
  language = DEFAULT_LANGUAGE;
  type: BookingItemType = BookingItemType.DEFINED;
  outlet: Outlet | null = null;
  brand: Brand | null = null;
  description = '';
  longDescription = '';
  code = '';
  operationCode = '';
  price: number | null = null;
  laborMinutes: number | null = null;
  isMaintenance = false;
  isDeleted = false;
  isB2CVisible = false;
  isQuoteItem = false;
  validFrom: Moment | null = null;
  validTill: Moment | null = null;

  get shortDescription(): string {
    return this.description;
  }

  set shortDescription(value: string) {
    this.description = value;
  }

  static create(): BookingItem {
    const item = new BookingItem();
    item.outlet = new Outlet();
    item.brand = new Brand();
    return item;
  }

  static forPlannerEvent(description: string, laborMinutes: number | null): BookingItem {
    const item = BookingItem.create();
    item.type = BookingItemType.KOR;
    item.description = description;
    item.laborMinutes = laborMinutes;
    return item;
  }
}
